module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('em', [_vm._v("Praise for Caitlin Kittredge")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("PURE BLOOD")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“"), _c('em', [_vm._v("Pure Blood")]), _vm._v(" pounds along hard on the heels of "), _c('em', [_vm._v("Night Life")]), _vm._v(", and is every bit as much fun as the first in the series. With a gutsy, likable protagonist and a well-made fantasy world, "), _c('em', [_vm._v("Pure Blood")]), _vm._v(" is real enough to make you think twice about locking your doors at night. A swiftly paced plot, a growing cast of solid supporting characters, and a lead character you can actually care about—Kittredge is a winner.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Jim Butcher")]), _vm._v(" "), _c('p', {
    staticClass: "linespace"
  }), _vm._v(" "), _c('p', {
    staticClass: "center-para"
  }, [_vm._v("NIGHT LIFE")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Dark and cutting-edge.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Romantic Times BOOKreviews")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“I loved the mystery and the smart, gutsy heroine.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Karen Chance,"), _c('br'), _c('em', [_vm._v("New York Times")]), _vm._v(" bestselling author of"), _c('br'), _c('em', [_vm._v("Claimed by Shadow")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Don’t go to bed with this book—it will keep you up all night. It’s that good.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Lilith Saintcrow,"), _c('br'), _vm._v("national bestselling author of"), _c('br'), _c('em', [_vm._v("Working for the Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Luna is tough, smart, and fierce, hiding a conflicted and insecure nature behind her drive for justice and independence, without falling into cliché. It’s also just a lot of fun to read.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_vm._v("—Kat Richardson,"), _c('br'), _vm._v("national bestselling author of "), _c('em', [_vm._v("Greywalker")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MORE")]), _vm._v("...")]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }, [_c('p', {
    staticClass: "para"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("“Fast-paced, sexy, and witty with many more interesting characters than I have time to mention. I’m looking forward to reading more stories in the exciting Nocturne City series.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Fresh Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Wow, I am still thinking about this book. The last time I reacted to a book this way, it was the first Mercy Thompson book by Patricia Briggs. If you are looking for a book that seamlessly blends a police procedural with a paranormal, go out and get this book.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Night Owl Reviews")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“A tense, gritty urban fantasy that grips the audience from the onset.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—The Mystery Gazette")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“"), _c('em', [_vm._v("Night Life")]), _vm._v(" dived right into the action, and carried me along for the ride…If the following books are written with the same care and interest as "), _c('em', [_vm._v("Night Life")]), _vm._v(", they will be a welcome addition to this fantasy genre.”")]), _vm._v(" "), _c('p', {
    staticClass: "right-para"
  }, [_c('em', [_vm._v("—Armchair Interviews")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2a088458","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter.vue
// module id = 57
// module chunks = 0